import { WidgetInstance } from 'friendly-challenge'
import { useCallback } from 'react'
import { create } from 'zustand'

interface CaptchaStore {
  widgetInstance: WidgetInstance | null
}

interface CaptchaStoreActions {
  setWidgetInstance: (widgetInstance: WidgetInstance) => void
  clearWidgetInstance: () => void
  resetWidgetInstance: () => void
}

const useCaptchaStore = create<CaptchaStore>(() => ({
  widgetInstance: null,
}))

export const useCaptchaStoreWidgetInstance = () =>
  useCaptchaStore((state) => state.widgetInstance)

export const useCaptchaStoreActions = (): CaptchaStoreActions => {
  const { setState, getState } = useCaptchaStore

  const setWidgetInstance: CaptchaStoreActions['setWidgetInstance'] =
    useCallback((widgetInstance) => setState({ widgetInstance }), [setState])

  const clearWidgetInstance: CaptchaStoreActions['clearWidgetInstance'] =
    useCallback(() => setState({ widgetInstance: null }), [setState])

  const resetWidgetInstance: CaptchaStoreActions['resetWidgetInstance'] =
    useCallback(() => {
      const { widgetInstance } = getState()
      widgetInstance?.reset()
    }, [getState])

  return {
    setWidgetInstance,
    clearWidgetInstance,
    resetWidgetInstance,
  }
}
